import React, { Component } from "react";

import "./Settings.css";

class Settings extends Component {
    constructor(props) {
        super(props);

        this.save = this.save.bind(this);
        this.add = this.add.bind(this);
        this.delete = this.delete.bind(this);

        this.formRef = React.createRef();
        this.addBannerFormRef = React.createRef();
        this.addMethodFormRef = React.createRef();
    }

    componentDidMount() {
        let { connection, toast } = this.props;

        connection
            .get_all_settings()
            .then((res) => {
                this.setState({ settings: res.data });
            })
            .catch((err) => {
                toast("تنظیمات", "خطا در بارگیری تنظیمات", " danger");
            });
    }

    add(group) {
        let { toast, connection } = this.props;
        let item;
        switch (group) {
            case "method":
                group = "offline_payment_methods";
                item = Object.fromEntries(
                    new FormData(this.addMethodFormRef.current)
                );
                if (item.number.length === 0) {
                    toast(
                        "افزودن روش پرداخت آفلاین",
                        " لطفا شماره را وارد کنید",
                        " warning"
                    );
                    return;
                }
                break;
            case "banner":
                group = "main_page_banners";
                item = Object.fromEntries(
                    new FormData(this.addBannerFormRef.current)
                );
                if (item.image.size === 0) {
                    toast("افزودن بنر", " لطفا یک عکس انتخاب کنید", " warning");
                    return;
                }

                item.file = item.image;
                item.image = URL.createObjectURL(item.image);

                break;

            default:
                break;
        }
        let { settings } = this.state;
        if (!settings) return;
        let g = settings[group];
        if (!g) return;
        g.push(item);
        settings[group] = g;
        this.setState({ settings });
        toast("افزودن مورد", " مورد اظافه شد", " confirm");
    }

    delete(group, index) {
        let { toast } = this.props;
        switch (group) {
            case "method":
                group = "offline_payment_methods";
                break;
            case "banner":
                group = "main_page_banners";
                break;
            default:
                break;
        }
        let { settings } = this.state;
        if (!settings) return;
        let g = settings[group];
        if (!g) return;
        g.splice(index, 1);
        settings[group] = g;
        this.setState({ settings });
        toast("حذف مورد", " مورد حذف شد", " confirm");
    }

    save() {
        let { toast, connection } = this.props;
        let { settings } = this.state;
        let formdata = Object.fromEntries(new FormData(this.formRef.current));
        let {
            mobile,
            phone,
            address,
            zip,
            packing_price_low_limit,
            packing_price_limit,
            packing_price_up_limit,
            postal_cost_factor,
            postal_cost_offset,
        } = formdata;
        settings.contact = { mobile, phone, address, zip };
        settings.costs = {
            packing_price_low_limit,
            packing_price_limit,
            packing_price_up_limit,
            postal_cost_factor,
            postal_cost_offset,
        };

        let forms = Array.from(window.document.getElementsByTagName("form"));

        let bannerForms =
            forms.filter((e) => {
                return e.id.includes("form-banner");
            }) || [];

        let methodForms =
            forms.filter((e) => {
                return e.id.includes("form-method");
            }) || [];

        bannerForms.forEach((bf) => {
            let form = Object.fromEntries(new FormData(bf));
            let banner = settings.main_page_banners.find((b) => {
                return b.link === form.link;
            });
            banner.label = form.label;
            banner.description = form.description;
            banner.link = form.link;
        });

        settings.offline_payment_methods = methodForms.map((mf) => {
            return Object.fromEntries(new FormData(mf));
        });
        const onUpload = (res) => {
            settings.main_page_banners = (settings.main_page_banners || []).map(
                (b) => {
                    if (b.file) {
                        b.image = (
                            res.find((r) => {
                                return r.name === b.file.name;
                            }) || {}
                        ).url;
                        delete b.file;
                    }
                    return b;
                }
            );
            connection
                .save_settings(settings)
                .then((res) => {
                    toast(
                        "ذخیره تغیرات",
                        "تغیرات با موفقیت ذخیره شدند",
                        " confirm"
                    );
                })
                .catch((err) => {
                    toast(
                        "ذخیره تغیرات",
                        "خطا در ذخیره تغیرات" + err,
                        " danger"
                    );
                });
        };
        connection
            .upload(
                (settings.main_page_banners || [])
                    .filter((b) => {
                        return b.file;
                    })
                    .map((b) => {
                        return b.file;
                    }),
                () => {}
            )
            .then((res) => {
                toast("آپلود ", "فایل ها آپلود شدند.", " confirm");
                onUpload(res);
            })
            .catch((err) => {
                toast("آپلود ", "خطا در آپلود فایل ها :" + err, " danger");
            });
    }

    state = {
        settings: null,
    };
    render() {
        let { settings } = this.state;
        let {
            contact,
            main_page_banners,
            offline_payment_methods,
            costs,
            is_ordering_open,
        } = settings || {};
        main_page_banners =
            main_page_banners && JSON.parse(JSON.stringify(main_page_banners));
        let { mobile, phone, address, zip } = contact || {};
        let {
            packing_price_low_limit,
            packing_price_limit,
            packing_price_up_limit,
            postal_cost_factor,
            postal_cost_offset,
        } = costs || {};
        return (
            <div className='SettingsComponent'>
                {settings && (
                    <div className='SettingsContainer'>
                        <form id='form' ref={this.formRef}></form>
                        <div className='offlinePaymentMethods'>
                            <div className='caption'>سفارش گذاری</div>
                            <div className='editable'>
                                سفارش گذاری باز باشد؟
                                <input
                                    type='checkbox'
                                    name='is_ordering_open'
                                    checked={is_ordering_open}
                                    onChange={(e) => {
                                        this.setState({
                                            ...Component,
                                            settings: {
                                                ...settings,
                                                is_ordering_open:
                                                    e.target.checked,
                                            },
                                        });
                                    }}
                                />
                                {is_ordering_open ? "باز است" : "بسته است"}
                            </div>
                        </div>
                        <div className='offlinePaymentMethods'>
                            <div className='caption'>
                                روش های واریز وجه آفلاین
                            </div>
                            <div className='editable'>
                                ویرایش؟
                                <input
                                    type='checkbox'
                                    name='editable_banners'
                                    form='form'
                                />
                            </div>
                            <div className='addMethod'>
                                <form
                                    id='addMethodForm'
                                    ref={this.addMethodFormRef}
                                ></form>
                                <div className='caption'>افزودن روش</div>
                                <div className='method'>
                                    <select name='method' form='addMethodForm'>
                                        <option value='کارت به کارت'>
                                            کارت به کارت
                                        </option>
                                        <option value='شبا'>شبا</option>
                                        <option value='حساب به حساب'>
                                            حساب به حساب
                                        </option>
                                    </select>
                                </div>
                                <div className='bank'>
                                    <div className='name'>بانک</div>
                                    <input
                                        type='text'
                                        name='bank'
                                        form='addMethodForm'
                                    />
                                </div>
                                <div className='name'>
                                    <div className='name'>نام صاحب حساب</div>
                                    <input
                                        type='text'
                                        name='name'
                                        form='addMethodForm'
                                    />
                                </div>
                                <div className='number'>
                                    <div className='name'>شماره</div>

                                    <input
                                        type='numbers'
                                        name='number'
                                        form='addMethodForm'
                                    />
                                </div>
                                <button
                                    className='add btn info'
                                    onClick={(ev) => this.add("method")}
                                >
                                    <i className='ri-add-line'></i>
                                    افزودن
                                </button>
                            </div>
                            {offline_payment_methods &&
                                offline_payment_methods.map((_method, i) => {
                                    let { method, bank, name, number } =
                                        _method;
                                    return (
                                        <div
                                            className='method'
                                            key={
                                                method +
                                                bank +
                                                name +
                                                number +
                                                i
                                            }
                                        >
                                            <form
                                                id={"form-method-" + i}
                                            ></form>
                                            <div className='method'>
                                                <div className='name'>روش</div>
                                                <select
                                                    name='method'
                                                    form={"form-method-" + i}
                                                    defaultValue={method}
                                                >
                                                    <option value='کارت به کارت'>
                                                        کارت به کارت
                                                    </option>
                                                    <option value='شبا'>
                                                        شبا
                                                    </option>
                                                    <option value='حساب به حساب'>
                                                        حساب به حساب
                                                    </option>
                                                </select>
                                            </div>
                                            <div className='bank'>
                                                <div className='name'>بانک</div>
                                                <input
                                                    type='text'
                                                    name='bank'
                                                    form={"form-method-" + i}
                                                    defaultValue={bank}
                                                />
                                            </div>
                                            <div className='name'>
                                                <div className='name'>
                                                    نام صاحب حساب
                                                </div>
                                                <input
                                                    type='text'
                                                    name='name'
                                                    form={"form-method-" + i}
                                                    defaultValue={name}
                                                />
                                            </div>
                                            <div className='number'>
                                                <div className='name'>
                                                    شماره
                                                </div>
                                                <input
                                                    type='text'
                                                    name='number'
                                                    form={"form-method-" + i}
                                                    defaultValue={number}
                                                />
                                            </div>
                                            <button
                                                className='delete btn danger'
                                                onClick={(ev) =>
                                                    this.delete("method", i)
                                                }
                                            >
                                                <i className='ri-delete-bin-5-line'></i>
                                            </button>
                                        </div>
                                    );
                                })}
                            <div className='addBanner'>{/* //TODO */}</div>
                        </div>
                        <div className='contact'>
                            <div className='caption'>مشخصات</div>
                            <div className='editable'>
                                ویرایش؟
                                <input
                                    type='checkbox'
                                    name='editable_banners'
                                    form='form'
                                />
                            </div>
                            {contact && (
                                <div className='contacts'>
                                    <div className='mobile'>
                                        <div className='name'>موبایل</div>
                                        <input
                                            form='form'
                                            type='tel'
                                            name='mobile'
                                            defaultValue={mobile}
                                        />
                                    </div>
                                    <div className='phone'>
                                        <div className='name'>تلفن ثابت</div>
                                        <input
                                            form='form'
                                            type='tel'
                                            name='phone'
                                            defaultValue={phone}
                                        />
                                    </div>
                                    <div className='address'>
                                        <div className='name'>آدرس</div>
                                        <input
                                            form='form'
                                            type='address'
                                            name='address'
                                            defaultValue={address}
                                        />
                                    </div>
                                    <div className='zip'>
                                        <div className='name'>کد پستی</div>
                                        <input
                                            form='form'
                                            type='zip'
                                            name='zip'
                                            defaultValue={zip}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='mainPageBanners'>
                            <div className='caption'>بنر های صفحه اصلی</div>
                            <div className='editable'>
                                ویرایش؟
                                <input
                                    type='checkbox'
                                    name='editable_banners'
                                    form='form'
                                />
                            </div>
                            <div className='addBanner'>
                                <form
                                    id='addBannerForm'
                                    ref={this.addBannerFormRef}
                                ></form>
                                <div className='caption'>افزودن بنر</div>
                                <div className='label'>
                                    <div className='name'>لیبل</div>
                                    <input
                                        type='text'
                                        name='label'
                                        form='addBannerForm'
                                    />
                                </div>
                                <div className='description'>
                                    <div className='name'>توضیحات</div>
                                    <input
                                        type='text'
                                        name='description'
                                        form='addBannerForm'
                                    />
                                </div>
                                <div className='link'>
                                    <div className='name'>لینک</div>
                                    <input
                                        type='text'
                                        name='link'
                                        form='addBannerForm'
                                    />
                                </div>
                                <div className='image'>
                                    <div className='name'>تصویر</div>
                                    <input
                                        type='file'
                                        name='image'
                                        form='addBannerForm'
                                        multiple={false}
                                        accept='image/*'
                                    />
                                </div>
                                <button
                                    className='add btn info'
                                    onClick={(ev) => {
                                        this.add("banner");
                                    }}
                                >
                                    <i className='ri-add-line'></i>
                                    افزودن
                                </button>
                            </div>
                            {main_page_banners &&
                                main_page_banners.reverse().map((banner, i) => {
                                    let {
                                        label,
                                        description,
                                        link,
                                        image,
                                        file,
                                    } = banner;
                                    return (
                                        <div
                                            className='banner'
                                            key={label + i + image}
                                        >
                                            <form
                                                id={"form-banner-" + i}
                                            ></form>
                                            <button
                                                className='delete btn danger'
                                                onClick={(ev) =>
                                                    this.delete(
                                                        "banner",
                                                        main_page_banners.length -
                                                            i -
                                                            1
                                                    )
                                                }
                                            >
                                                <i className='ri-delete-bin-5-line'></i>
                                                حذف
                                            </button>
                                            {file && (
                                                <div className='new btn info'>
                                                    جدید
                                                </div>
                                            )}
                                            <div className='label'>
                                                <div className='name'>لیبل</div>
                                                <input
                                                    type='text'
                                                    name='label'
                                                    form={"form-banner-" + i}
                                                    defaultValue={label}
                                                />
                                            </div>
                                            <div className='description'>
                                                <div className='name'>
                                                    توضیحات
                                                </div>
                                                <input
                                                    type='text'
                                                    name='description'
                                                    form={"form-banner-" + i}
                                                    defaultValue={description}
                                                />
                                            </div>
                                            <div className='link'>
                                                <div className='name'>لینک</div>
                                                <input
                                                    type='text'
                                                    name='link'
                                                    form={"form-banner-" + i}
                                                    defaultValue={link}
                                                />
                                            </div>
                                            <div className='image'>
                                                <div className='name'>
                                                    آدرس تصویر
                                                </div>
                                                <textarea
                                                    type='url'
                                                    name='image'
                                                    form={"form-banner-" + i}
                                                    defaultValue={image}
                                                    rows={3}
                                                    disabled
                                                />
                                                <img src={image} />
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>

                        <div className='costs'>
                            <div className='caption'>فرمول هزینه ها</div>
                            <div className='editable'>
                                ویرایش؟
                                <input
                                    type='checkbox'
                                    name='editable_banners'
                                    form='form'
                                />
                            </div>
                            <div className='attention '>
                                <i className='ri-error-warning-line text warning'></i>
                                تغیرات در این بخش میتواند بسیار خطرناک باشد.
                                لطفا قبل از اعمال تغیرات با توسعه دهنده مشورت
                                کنید!
                            </div>

                            {costs && (
                                <div className='costs'>
                                    <div className='packing_price_limit'>
                                        <div className='name'>
                                            نقطه عطف هزینه بسته بندی
                                        </div>
                                        <input
                                            form='form'
                                            type='number'
                                            name='packing_price_limit'
                                            defaultValue={packing_price_limit}
                                        />
                                        کیلوگرم
                                    </div>
                                    <div className='packing_price_low_limit'>
                                        <div className='name'>
                                            هزینه بسته بندی کمتر از نقطه عطف
                                        </div>
                                        <input
                                            form='form'
                                            type='number'
                                            name='packing_price_low_limit'
                                            defaultValue={
                                                packing_price_low_limit
                                            }
                                        />
                                        تومان
                                    </div>

                                    <div className='packing_price_up_limit'>
                                        <div className='name'>
                                            هزینه بسته بندی بیشتر از نقطه عطف
                                        </div>
                                        <input
                                            form='form'
                                            type='number'
                                            name='packing_price_up_limit'
                                            defaultValue={
                                                packing_price_up_limit
                                            }
                                        />
                                        تومان
                                    </div>
                                    <div className='postal_cost_factor'>
                                        <div className='name'>
                                            ضریب هزینه پسنی
                                        </div>
                                        <input
                                            form='form'
                                            type='number'
                                            name='postal_cost_factor'
                                            defaultValue={postal_cost_factor}
                                        />
                                    </div>
                                    <div className='postal_cost_offset'>
                                        <div className='name'>
                                            عرض از مبدا هزینه پستی
                                        </div>
                                        <input
                                            form='form'
                                            type='number'
                                            name='postal_cost_offset'
                                            defaultValue={postal_cost_offset}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='actions'>
                            <button
                                className='save confirm btn'
                                onClick={this.save}
                            >
                                <i className='ri-save-2-line'></i>
                                ذخیره
                            </button>
                            <button
                                className='discard danger btn'
                                onClick={() => {
                                    window.location.reload();
                                }}
                            >
                                <i className='ri-close-line'></i>
                                کنار گذاشتن تغیرات
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Settings;
